require('alpinejs');

require('lightgallery.js');

const galleries = document.querySelectorAll('[data-lightgallery]');

galleries.forEach(o => lightGallery(o, {
    selector: '.item'
}));

// for posts, make external links target="_blank"
document.querySelectorAll('#content article')
    .forEach(el => {
        if (el.host === window.location.host) return;
        el.target = '_blank';
    });
